/* Guided-selling diaper quiz — client-side state machine.
   Each [data-quiz] instance: entry button opens a full-screen overlay, user
   answers 3 questions — Q1 stage (data-stage), Q2 change-style (data-pick),
   Q3 weight (data-weight). Q3's weight options are filtered by the chosen stage
   so the inputs can't contradict (a newborn can't pick 14kg). Stage drives the
   type (newborn→dán, walking→quần; crawling = change-style/weight tiebreak);
   weight maps to size. No backend: product URLs/names from root data-* attrs. */
(function () {
  // Size by weight bucket, per product type (Merria size chart). Buckets that
  // can't occur for a type (dán >11kg) are simply absent.
  var SIZE = {
    dan: { u8: 'NB/S', '8_11': 'M' },
    quan: { u8: 'M', '8_11': 'M', '11_14': 'L', o14: 'XL trở lên' }
  };
  var DESC = {
    dan: 'Mềm dịu, dễ thay và dễ chỉnh eo khi bé còn nằm nhiều — ôm gọn bé sơ sinh.',
    quan: 'Mặc nhanh như quần, ôm theo cử động — tiện khi bé biết lẫy, bò, vận động nhiều.'
  };

  function initQuiz(root) {
    var overlay = root.querySelector('[data-quiz-overlay]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.collection-quiz__step'));
    if (!overlay || !steps.length) return;

    var picks = [];      // 'dan' | 'quan' per answered question (Q2 is the meaningful one)
    var weight = null;   // bucket from Q3
    var stage = null;    // 'newborn' | 'crawl' | 'walk' from Q1

    function show(stepName) {
      steps.forEach(function (s) { s.hidden = String(s.getAttribute('data-step')) !== String(stepName); });
    }
    // Show only the weight buckets that make sense for the chosen stage.
    function filterWeights() {
      var step3 = root.querySelector('.collection-quiz__step[data-step="3"]');
      if (!step3) return;
      step3.querySelectorAll('.collection-quiz__option').forEach(function (o) {
        var stages = (o.getAttribute('data-stages') || '').split(/\s+/);
        o.hidden = !!stage && stages.indexOf(stage) === -1;
      });
    }
    function openOverlay() {
      reset();
      overlay.hidden = false;
      document.documentElement.classList.add('quiz-open');
      var first = overlay.querySelector('.collection-quiz__option');
      if (first) first.focus();
    }
    function closeOverlay() {
      overlay.hidden = true;
      document.documentElement.classList.remove('quiz-open');
    }
    function reset() { picks = []; weight = null; stage = null; filterWeights(); show('1'); }

    function decide() {
      var overWeight = weight === '11_14' || weight === 'o14'; // beyond tã dán's range
      var type;
      if (stage === 'newborn') type = 'dan';
      else if (stage === 'walk') type = 'quan';
      else type = overWeight || picks[1] === 'quan' ? 'quan' : 'dan'; // crawl = overlap
      if (overWeight && type === 'dan') type = 'quan';                // dán tops out at M (~11kg)
      var size = (SIZE[type] && SIZE[type][weight]) || '';
      return { type: type, size: size };
    }

    function renderResult() {
      var r = decide();
      var name = root.getAttribute('data-' + r.type + '-name') || (r.type === 'dan' ? 'Tã dán' : 'Tã quần');
      var url = root.getAttribute('data-' + r.type + '-url') || '#';
      var title = root.querySelector('[data-result-title]');
      var desc = root.querySelector('[data-result-desc]');
      var link = root.querySelector('[data-result-link]');
      if (title) title.textContent = r.size ? (name + ' · Size ' + r.size) : name;
      if (desc) desc.textContent = DESC[r.type];
      if (link) { link.setAttribute('href', url); link.textContent = 'Xem ' + name; }
      show('result');
    }

    // Option click → record pick/weight, advance.
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.collection-quiz__option');
      if (opt && root.contains(opt)) {
        var step = opt.closest('.collection-quiz__step');
        var idx = parseInt(step.getAttribute('data-step'), 10);
        if (opt.hasAttribute('data-stage')) stage = opt.getAttribute('data-stage');
        if (opt.hasAttribute('data-pick')) picks[idx - 1] = opt.getAttribute('data-pick');
        if (opt.hasAttribute('data-weight')) weight = opt.getAttribute('data-weight');
        if (idx === 1) filterWeights(); // make Q3 weights consistent with the stage
        if (idx < 3) show(String(idx + 1)); else renderResult();
        return;
      }
      if (e.target.closest('[data-quiz-open]')) { openOverlay(); return; }
      if (e.target.closest('[data-quiz-close]')) { closeOverlay(); return; }
      if (e.target.closest('[data-quiz-restart]')) { reset(); return; }
      // Click on the dimmed backdrop (overlay itself, not the panel) closes it.
      if (e.target === overlay) closeOverlay();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeOverlay();
    });
  }

  function boot() {
    document.querySelectorAll('[data-quiz]').forEach(initQuiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-quiz]').forEach(initQuiz);
  });
})();
